<template>
  <div
    class="register-landing d-flex justify-center align-center"
    style="height: 100%; position: relative; background: transparent linear-gradient(180deg, #1c1632 0%, #000000 100%) 0 0 no-repeat padding-box"
  >
    <app-dialog
      :dialogShow="registerSuccessDialogShow"
      :isRegSuccess="true"
      ref="registerSuccessDialog"
      :max-width="400"
      :title="$t(`label.registerSuccess`)"
      :closeAction="this.closeRegisterSuccessDialog"
    >
      <app-register-success :closeRegisterSuccessDialog="closeRegisterSuccessDialog"></app-register-success>
    </app-dialog>
    <div>
      <app-dialog :dialogShow="pageDialogShow" :max-width="400" :title="pageDialog.title" :closeAction="this.pageDialog.dialogXButton">
        <app-page-dialog
          :dialogMessageTitle="pageDialog.messageTitle"
          :dialogMessage="pageDialog.message"
          :dialogButton="pageDialog.button"
          :dialog-attachments="pageDialog.attachment"
        ></app-page-dialog>
      </app-dialog>
      <v-btn icon class="back-button-landing-page" @click="backToHome()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-row class="d-flex justify-space-around pb-6">
        <router-link :to="{ name: ROUTE_NAME.HOME }" class="d-flex justify-center align-center">
          <img width="300px" height="80px" src="/static/svg/logo.png" alt="krikya logo" />
        </router-link>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <h2 class="pt-2 mb-0 justify-center align-center d-flex">
            <label class="white--text">{{ $t(`label.register`) }}</label>
          </h2>
        </v-col>
      </v-row>
      <!--      <p class="mt-5 text-center body-1">-->
      <!--        {{ $t(`message.alreadyHaveAccount`) }}-->
      <!--        <v-btn text height="auto" @click="openLogin" class="pa-0 text-uppercase font-weight-bold secondary&#45;&#45;text">{{ $t(`label.signIn`) }}</v-btn>-->
      <!--      </p>-->
      <v-row no-gutters class="register_panel-af" style="background: transparent !important;">
        <v-row no-gutters class="register-wrapper-af align-center justify-center">
          <v-col cols="9" class="no-gutters">
            <v-window v-model="step" :touchless="true">
              <v-window-item :value="1" :key="1">
                <v-form ref="registerForm1">
                  <v-card-text class="ma-0 pa-0">
                    <app-form-field
                      class="registerformfield register-landing-text-field white--text"
                      ref="regMemberCode"
                      :enabledLabel="true"
                      v-model.trim="registerObj.memberCode"
                      :label="$t(`field.username`)"
                      :placeholder="$t(`fieldHint.username`)"
                      key="username"
                      :errorMsg="userNameErrorMsg"
                      :blur="checkUsername"
                      :rules="validator.usernameRules(registerObj.password)"
                    ></app-form-field>
                    <app-form-field
                      class="registerformfield register-landing-text-field white--text"
                      ref="regPassword"
                      :enabledLabel="true"
                      v-model.trim="registerObj.password"
                      :label="$t(`field.password`)"
                      :placeholder="$t(`fieldHint.password2`)"
                      :rules="validator.changePasswordRules(registerObj.memberCode)"
                      :allowShowPassword="false"
                      type="password"
                      prependInnerIcon="mdi-lock-outline"
                    ></app-form-field>
                    <app-form-field
                      class="registerformfield register-landing-text-field white--text"
                      :enabledLabel="true"
                      v-model.trim="confirmNewPassword"
                      :label="$t(`field.confirmPassword`)"
                      :placeholder="$t(`fieldHint.confirmPassword`)"
                      :rules="validator.confirmPasswordRules(registerObj.password, confirmNewPassword)"
                      :allowShowPassword="false"
                      type="password"
                      prependInnerIcon="mdi-lock-outline"
                    ></app-form-field>
                  </v-card-text>
                </v-form>

                <v-form ref="registerForm2">
                  <v-row no-gutters class="d-none">
                    <v-col cols="12">
                      <app-form-field
                        :enabledLabel="true"
                        v-model.trim="registerObj.currency"
                        :label="$t(`field.currency`)"
                        type="select"
                        :disabled="true"
                        height:30
                        :rules="validator.dropDownListRules()"
                        :items="currencyList"
                        class="registerformfield black--text"
                      ></app-form-field>
                    </v-col>
                  </v-row>
                  <v-card-text class="ma-0 pa-0">
                    <label class="input-field-label ma-0 white--text pb-2 text-capitalize d-block">
                      {{ $t(`field.phoneNumber`) }}
                      <span class="red--text ml-1">*</span>
                    </label>
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-select
                          elevation="2"
                          v-model.trim="registerObj.dialCode"
                          class="registerformfield register-landing-text-field white--text input-field mr-2 black--text"
                          item-text="text"
                          item-value="value"
                          :items="mobileNumberPrefixList"
                          dense
                          outlined
                          :readonly="true"
                        >
                          <template #prepend-inner>
                            <v-btn icon small>
                              <v-avatar size="25" class="language-button">
                                <img width="25" height="25" :src="`/static/image/country/${currentCurrency}.svg`" alt="kk cricket exchange" />
                              </v-avatar>
                            </v-btn>
                          </template>
                        </v-select>
                      </v-col>

                      <v-col cols="6" ref="phonenumber">
                        <app-form-field
                          class="registerformfield register-landing-text-field 14fontsize"
                          :enabledLabel="false"
                          v-model.trim="registerObj.mobileNumber"
                          :rules="validator.mobileNumberRules(registerObj.language)"
                          :placeholder="$t(`fieldHint.phoneNumber2`)"
                          :isOptional="true"
                        ></app-form-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
                <v-form ref="registerForm3">
                  <v-card-text class="ma-0 pa-0">
                    <v-row no-gutters class="d-none">
                      <v-col cols="12">
                        <app-form-field
                          class="registerformfield"
                          :enabledLabel="true"
                          v-model.trim="registerObj.email"
                          :label="$t(`field.email`)"
                          :isOptional="true"
                          :placeholder="$t(`fieldHint.fillEmail`)"
                          :rules="validator.emailRules()"
                        ></app-form-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="d-none">
                      <v-col cols="12">
                        <app-form-field
                          class="registerformfield specialgrey"
                          :enabledLabel="true"
                          :label="$t(`field.referralCode`)"
                          readonly
                          :rules="validator.referralCodeRules()"
                          :isOptional="true"
                          v-model.trim="registerObj.referralCode"
                        ></app-form-field>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-checkbox class="mt-0 pt-0 register-landing-check-box" :rules="validator.requiredRules()">
                          <template v-slot:label>
                            <p class="caption pt-0 mb-0">
                              <label class="font-weight-bold white--text" style="cursor: pointer; font-size: 14px !important;">
                                {{ $t(`label.policy`) }}
                              </label>
                            </p>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex justify-center align-center">
                      <v-btn width="100%" class="circle-button text-capitalize" style="color: #fff; background: transparent linear-gradient(180deg, #FFAB2D 0%, #FF7700 100%);" @click="this.register">
                        {{ $t(`button.joinNow`) }}
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-row>
      <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
        <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="mdi-close"
        >
          {{ alertMessage }}
        </v-alert>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import stringFormat from 'string-format'
import { formValidator, uiHelper, locale } from '@/util'
import {
  MEMBER_CHECK_USERNAME,
  MEMBER_RESET_CHECK_USERNAME,
  MEMBER_REGISTER,
  MEMBER_SMS_REQUEST,
  MEMBER_SMS_VERIFY,
  MEMBER_GET_SMS_REQUIREMENT,
  MEMBER_RESET_SMS_VERIFICATION,
  MEMBER_RESET_REGISTER_STORE,
  MEMBER_REGISTER_LOGIN,
  MEMBER_REGISTER_LOGIN_RESET
} from '@/store/member.module'
import { SESSION, SHARED } from '@/constants/constants'
import { errorCodeHelper } from '@/util/error-code-helper'
import { ROUTE_NAME } from '@/constants/route.constants'
import AppPageDialog from '@/components/layout/PageDialog.vue'
import AppRegisterSuccess from '@/components/member/registerSuccess.vue'
import { GET_FACEBOOK_PIXEL, POST_CHANNEL_PAGE_VIEW } from '@/store/facebookpixel.module'

export default {
  name: 'registerLanding',
  components: { AppRegisterSuccess, AppPageDialog },
  mounted() {
    this.$refs.registerForm1.reset()
    this.$refs.registerForm3.reset()
    this.checkAffiliateReferralCode()
    this.checkPhoneVerificationRequirements()
  },
  props: {
    openLoginDialog: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  async created() {
    this.getFacebookPixels()
    this.metaTag()
    this.checkReferCode()
    try {
      srtmCommands.push({
        event: 'track.user.registration',
        payload: {
          action: 'start'
        }
      })
    } catch (err) {
      console.log(err)
    }
    await uiHelper.getFingerprints()
    await this.checkChannelID()
  },
  data: () => ({
    registerSuccessDialogShow: false,
    pageDialogShow: false,
    pageDialog: {
      title: '',
      closePageDialog: () => {},
      messageTitle: '',
      message: [],
      button: []
    },
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    currentCurrency: uiHelper.getCurrency(),
    currentLanguage: uiHelper.getLanguage(),
    defaultLanguage: SHARED.DEFAULT_LANGUAGE,
    registerTncUrl: '',
    registerTncDialog: {
      show: false,
      title: locale.getMessage(`label.registerAccountAgreement`)
    },
    validator: formValidator,
    stringFormat: stringFormat,
    isReferralCodeReadonly: false,
    confirmNewPassword: '',
    mobileNumberPrefixList: [
      {
        text: '+91',
        value: '91',
        currency: 'INR',
        lang: 'id'
      },
      {
        text: '+880',
        value: '880',
        currency: 'BDT',
        lang: 'bd'
      }
    ],
    currencyList: ['INR', 'BDT'],
    registerObj: {
      memberCode: '',
      password: '',
      currency: SHARED.DEFAULT_CURRENCY,
      email: '',
      dialCode: uiHelper.getDialCode(),
      mobileNumber: '',
      verificationCode: '',
      line: '',
      referralCode: '',
      isEarlyBird: '0',
      domain: '',
      language: SHARED.DEFAULT_LANGUAGE,
      platform: '',
      fp: '',
      agent_team: '',
      utm_source: uiHelper.getCookie(SESSION.UTM_SOURCE),
      utm_medium: uiHelper.getCookie(SESSION.UTM_MEDIUM),
      utm_campaign: uiHelper.getCookie(SESSION.UTM_CAMPAIGN),
      s2: uiHelper.getCookie(SESSION.UTM_S2),
      pid: uiHelper.getCookie(SESSION.PID),
      c_id: uiHelper.getCookie(SESSION.CLICKID),
      stag: uiHelper.getCookie(SESSION.STAG),
      tracking_link: uiHelper.getCookie(SESSION.TRACKING_LINK),
      fbPixelId: '',
      fbp: uiHelper.getCookie(SESSION.FB_P),
      fbc: uiHelper.getCookie(SESSION.FB_C),
      channel_id: uiHelper.getCookie(SESSION.CHANNEL_ID)
    },
    confirmedPassword: '',
    step: 1,
    regSteps: 2,
    banners: ['/static/image/register/'],
    errorMsg: undefined,
    userNameErrorMsg: undefined,
    alertShow: false,
    alertSuccess: false,
    alertMessage: ''
  }),
  computed: {
    facebookPixels() {
      return this.$store.state.facebookPixel.facebookPixels
    },
    registerResponseComplete() {
      return this.$store.state.member.registerResponse.complete
    },
    registerLoginComplete() {
      return this.$store.state.member.registerLoginResponse.complete
    },
    ROUTE_NAME() {
      return ROUTE_NAME
    },
    smsRequired() {
      return this.$store.state.member.smsVerificationRequired.required
    },
    smsVerificationSent() {
      return this.$store.state.member.smsVerificationSent.success
    },
    smsVerificationResult() {
      return this.$store.state.member.smsVerificationResult.success
    },
    smsVerificationError() {
      return this.$store.state.member.smsVerificationResult.message
    },
    smsRequestError() {
      return this.$store.state.member.smsVerificationSent.message
    },
    smsRequestAvailable() {
      return this.$store.state.member.smsVerificationSent.countDownTimer <= 0
    },
    smsCountdownTimer() {
      return this.$store.state.member.smsVerificationSent.countDownTimer.toString()
    },
    checkUsernameResult() {
      return this.$store.state.member.checkUsernameResult.completed
    },
    watchCurrency() {
      return this.registerObj.currency
    }
  },
  watch: {
    facebookPixels: {
      handler(newVal) {
        if (newVal.complete && newVal.success && newVal.data) {
          this.initFacebookPixels(newVal.data)
        }
      },
      immediate: true,
      deep: true
    },
    registerLoginComplete() {
      let response = this.$store.state.member.registerLoginResponse
      if (response.success) {
        console.log('set cookie to true')
        uiHelper.setCookie('popUpSuccessDialog', true)
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)

          if (response.success && uiHelper.getCookie(SESSION.USERNAME)) {
            this.AdElementAfterRegistered(uiHelper.getCookie(SESSION.USERNAME))
          }
        } catch (err) {
          console.log(err)
        }
        this.$router.push({
          name: ROUTE_NAME.HOME,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else if (response.code != 0) {
        this.openAlert(response.success, response.error)
        this.$store.dispatch(`${MEMBER_REGISTER_LOGIN_RESET}`)
      }
    },
    registerResponseComplete() {
      let response = this.$store.state.member.registerResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)

          if (response.success && response.membercode) {
            this.AdElementAfterRegistered(response.membercode)
          }
        } catch (err) {
          console.log(err)
        }
        this.registerResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_REGISTER_STORE}`)
      }
    },
    watchCurrency() {
      const selected = this.mobileNumberPrefixList.find(x => x.currency == this.registerObj.currency)
      if (selected) {
        this.registerObj.dialCode = selected.value
      }
    },
    smsRequestError() {
      if (this.$store.state.member.smsVerificationSent.complete && !this.$store.state.member.smsVerificationSent.success) {
        this.errorDialog(this.$store.state.member.smsVerificationSent.code)
      }
    },
    checkUsernameResult() {
      if (this.$store.state.member.checkUsernameResult.completed) {
        if (this.$store.state.member.checkUsernameResult.success) {
          this.userNameErrorMsg = undefined
        } else {
          if (this.$store.state.member.checkUsernameResult.code == -2) {
            this.userNameErrorMsg = locale.getMessage(`fieldErrorMessage.usernameExceedLength`)
          } else if (this.$store.state.member.checkUsernameResult.code == -1) {
            this.userNameErrorMsg = locale.getMessage(`fieldErrorMessage.usernameUsed`)
          }
        }
        this.$store.dispatch(`${MEMBER_RESET_CHECK_USERNAME}`)
      }
    }
  },
  methods: {
    async checkChannelID() {
      const channelDbId = uiHelper.getCookie(SESSION.CHANNEL_ID)
      if (!channelDbId) return

      const guardKey = `pv_sent:${channelDbId}`
      if (sessionStorage.getItem(guardKey)) return

      // This will return the cookie if it exists, or generate+store a new one
      let fp = await uiHelper.getFingerprints()

      try {
        await this.$store.dispatch(POST_CHANNEL_PAGE_VIEW, {
          channelDbId,
          fingerprint: fp || null,
          referrer: null
        })
        sessionStorage.setItem(guardKey, '1')
      } catch (e) {
        console.log('pageview failed', e)
      }
    },
    initFacebookPixels(pixelData) {
      let noscriptInserted = false

      pixelData.forEach(pixelConfig => {
        const baseDomain = pixelConfig.domain.replace(/^www\./, '')
        const domainRegex = new RegExp(`(^|\\.)?(www\\.)?${baseDomain.replace(/\./g, '\\.')}$`)
        if (domainRegex.test(window.location.hostname)) {
          if (!window.fbq) {
            ;(function(f, b, e, v, n, t, s) {
              if (f.fbq) return
              n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              }
              if (!f._fbq) f._fbq = n
              n.push = n
              n.loaded = true
              n.version = '2.0'
              n.queue = []
              t = b.createElement(e)
              t.async = true
              t.src = v
              s = b.getElementsByTagName(e)[0]
              s.parentNode.insertBefore(t, s)
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
          }

          fbq('init', pixelConfig.fb_pixel_id)
          fbq('track', 'PageView')
          console.log(`FB Pixel loaded: ${pixelConfig.fb_pixel_id} for ${pixelConfig.domain}`)

          // ✅ Insert <noscript> only once for the first matching pixel
          if (!noscriptInserted) {
            uiHelper.setCookie(SESSION.FB_PIXEL_CODE, pixelConfig.fb_pixel_id, 30)
            const noscript = document.createElement('noscript')
            noscript.innerHTML = `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelConfig.fb_pixel_id}&ev=PageView&noscript=1" />`
            document.body.appendChild(noscript)
            noscriptInserted = true
          }
        }
      })
    },
    getFacebookPixels() {
      this.$store.dispatch(GET_FACEBOOK_PIXEL)
    },
    backToHome() {
      this.$router.push({
        name: ROUTE_NAME.HOME
      })
    },
    closeRegisterSuccessDialog() {
      this.registerSuccessDialogShow = false
    },
    registerResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closeDialog
        })
        this.pageDialog.dialogXButton = this.closeDialog()
        this.openPageDialog(dialog)
        this.registerErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      } else {
        //sportradar register complete
        try {
          srtmCommands.push({
            event: 'track.user.registration',
            payload: {
              action: 'complete',
              userId: this.$store.state.member.registerResponse.membercode
            }
          })
          console.log('done reg sradar!')
        } catch (err) {
          console.log(err)
        }

        this.registerSuccessDialogShow = true
        let vm = this
        setTimeout(function() {
          this.registerSuccessDialogShow = false
          vm.$router.push({
            name: ROUTE_NAME.FUNDS
          })
        }, 5000)
      }
    },
    checkReferCode() {
      // this.clearAFCookiesByDomains();
      let af = this.$route.query.af
      let r = this.$route.query.refer_code
      let u_s = this.$route.query.utm_source
      let u_m = this.$route.query.utm_medium
      let u_c = this.$route.query.utm_campaign
      let s2 = this.$route.query.s2
      let pid = this.$route.query.sub1
      let refid = this.$route.query.ref_id
      let stag = this.$route.query.stag
      let tracking_link = this.$route.query.tracking_link
      let fbPixelId = this.$route.query.fbPixelId
      let channelID = this.$route.query.i
      try {
        let old_af = uiHelper.getCookie(SESSION.AFF_CODE)
        if (typeof old_af != 'undefined' && old_af != '' && old_af != null) {
          if (old_af !== af) {
            //if old af not match clear all pixel info.
            uiHelper.removeCookie(SESSION.PID)
            uiHelper.removeCookie(SESSION.CLICKID)
            uiHelper.removeCookie(SESSION.UTM_SOURCE)
            uiHelper.removeCookie(SESSION.UTM_MEDIUM)
            uiHelper.removeCookie(SESSION.UTM_CAMPAIGN)
            uiHelper.removeCookie(SESSION.UTM_S2)
          }
        }
      } catch (err) {
        console.log(err)
      }

      var domain = window.location.hostname
      var wwwDomain = domain.replace(/^www\./, '') // Remove "www." if it exists

      // Create a dictionary to map domains to expiration days
      var expirationDaysByDomain = {
        //first array = third party aff / second = agent code
        'krikya.com': [30, 30],
        'krikya.app': [30, 30],
        'krikya88.com': [30, 365],
        'krikya11.net': [30, 30],
        'krikya.pro': [30, 30],
        'krikya.club': [30, 30],
        'krikya.co': [30, 30],
        'krikya.group': [30, 30],
        'krikya22.com': [30, 30],
        'krikya44.com': [30, 30],
        'krikya55.com': [30, 30],
        'krikya66.com': [30, 30],
        'krikya77.com': [30, 365]
        // Add more domains and expiration days as needed
      }

      // Set the expiration day based on the domain
      var expirationDaysArray = expirationDaysByDomain[wwwDomain]

      // Default expiration (e.g., 1 day) if the domain is not in the dictionary or the array is not valid
      var expirationDaysThirdParty = 1
      var expirationDaysAgent = 365

      if (expirationDaysArray && expirationDaysArray.length === 2) {
        // Your logic to choose between short and long expiration here
        // For example, you can check some condition to decide:
        expirationDaysThirdParty = expirationDaysArray[0] // Use short expiration
        expirationDaysAgent = expirationDaysArray[1]
      }

      if (typeof stag != 'undefined' && stag != '' && stag != null) {
        uiHelper.setCookie(SESSION.STAG, stag, expirationDaysThirdParty)
      }
      if (typeof tracking_link != 'undefined' && tracking_link != '' && tracking_link != null) {
        uiHelper.setCookie(SESSION.TRACKING_LINK, tracking_link, expirationDaysThirdParty)
      }
      //PID at here set to utm_source
      if (typeof pid != 'undefined' && pid != '' && pid != null) {
        uiHelper.setCookie(SESSION.PID, pid, expirationDaysThirdParty)
      }
      //REFID at here set to utm_s2
      if (typeof refid != 'undefined' && refid != '' && refid != null) {
        uiHelper.setCookie(SESSION.CLICKID, refid, expirationDaysThirdParty)
      }
      if (typeof u_s != 'undefined' && u_s != '' && u_s != null) {
        uiHelper.setCookie(SESSION.UTM_SOURCE, u_s, expirationDaysThirdParty)
      }
      if (typeof u_m != 'undefined' && u_m != '' && u_m != null) {
        uiHelper.setCookie(SESSION.UTM_MEDIUM, u_m, expirationDaysThirdParty)
      }
      if (typeof u_c != 'undefined' && u_c != '' && u_c != null) {
        uiHelper.setCookie(SESSION.UTM_CAMPAIGN, u_c, expirationDaysThirdParty)
      }
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, expirationDaysThirdParty)
      }
      if (typeof fbPixelId != 'undefined' && fbPixelId != '' && fbPixelId != null) {
        uiHelper.setCookie(SESSION.FB_PIXEL_CODE, fbPixelId, expirationDaysAgent)
      }
      if (typeof channelID != 'undefined' && channelID != '' && channelID != null) {
        uiHelper.setCookie(SESSION.CHANNEL_ID, channelID, expirationDaysThirdParty)
      }
      if (typeof af != 'undefined' && af != '' && af != null) {
        uiHelper.setCookie(SESSION.AFF_CODE, af, expirationDaysAgent)
      } else {
        if (typeof r != 'undefined' && r != '' && r != null) {
          uiHelper.setCookie(SESSION.REFER_CODE, r, expirationDaysAgent)
        }
      }
    },
    metaTag() {
      //uiHelper.setMetaTag('url', 'https://www.krikya.group/register/')
      uiHelper.setTitle(`${locale.getMessage('meta.register_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.register_description')}`)
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.register_keyword')}`)
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      uiHelper.setMetaTag('url', currentUrl)
      const origin = window.location.origin
      let setLink = `${origin}/${this.currentLanguage === 'en' ? 'en-BD' : 'bn-BD'}`
      uiHelper.setCanonical(setLink)
    },
    checkUsername() {
      if (this.registerObj.memberCode.trim() !== '') {
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_CHECK_USERNAME}`, {
          registerObj
        })

        this.$refs.regPassword.validate()
      }
    },
    errorDialog(errorCode) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.register`)
      dialog.dialogXButton = null
      dialog.message.push(errorCodeHelper.getErrorCodeDesc(errorCode))
      dialog.button.push({
        title: locale.getMessage(`label.close`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    openPageDialog(dialog) {
      this.pageDialog = dialog
      this.pageDialogShow = true
    },
    closeDialog() {
      this.pageDialogShow = false
    },
    closePageDialog() {
      this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      this.$eventHub.$emit('close-page-dialog', true)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    checkPhoneVerificationRequirements() {
      this.$store.dispatch(`${MEMBER_GET_SMS_REQUIREMENT}`)
    },
    openRegisterTncDialog() {
      this.registerTncUrl = `${process.env.BASE_URL}static/html/other/${uiHelper.getLanguage()}/register-tnc.html`
      this.registerTncDialog.show = true
      this.registerTncDialog.dialogXButton = this.closePromotionTncDialog
    },
    closeRegisterTncDialog() {
      this.registerTncDialog.show = false
    },
    openLogin() {
      this.openLoginDialog()
    },

    register() {
      // if (this.smsRequired && !this.smsVerificationSent && !this.smsVerificationResult.success) {
      //   this.requestSmsVerificationCode()
      //   return
      // }
      if (this.$refs.registerForm1.validate() && this.$refs.registerForm2.validate() && this.$refs.registerForm3.validate()) {
        let jObj = this
        this.registerObj.platform = uiHelper.getPlatform()
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        this.registerObj.fbPixelId = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
        this.registerObj.fbp = uiHelper.getCookie(SESSION.FB_P)
        this.registerObj.fbc = uiHelper.getCookie(SESSION.FB_C)
        this.registerObj.channel_id = uiHelper.getCookie(SESSION.CHANNEL_ID)
        let existFp = typeof uiHelper.getCookie('fp_visitor') != 'undefined' && uiHelper.getCookie('fp_visitor') != null && uiHelper.getCookie('fp_visitor') != ''
        if (existFp) {
          jObj.registerObj.fp = uiHelper.getCookie('fp_visitor')
          let registerObj = this.registerObj
          this.$store.dispatch(`${MEMBER_REGISTER_LOGIN}`, {
            registerObj
          })
        } else {
          try {
            jObj.registerObj.fp = uiHelper.getFingerprints()
            if (jObj.registerObj.fp != '' && jObj.registerObj.fp != null) {
              uiHelper.setCookie('fp_visitor', jObj.registerObj.fp, 30)
              let registerObj = jObj.registerObj
              this.$store.dispatch(`${MEMBER_REGISTER_LOGIN}`, {
                registerObj
              })
            }
          } catch (err) {
            log(err)
            let registerObj = this.registerObj
            this.$store.dispatch(`${MEMBER_REGISTER_LOGIN}`, {
              registerObj
            })
          }
          //this.registerObj.currency = uiHelper.getCurrency()
        }
      }
    },
    formatSeconds(secs) {
      const pad = n => (n < 10 ? `0${n}` : n)

      const h = Math.floor(secs / 3600)
      const m = Math.floor(secs / 60) - h * 60
      const s = Math.floor(secs - h * 3600 - m * 60)

      return `${pad(m)}:${pad(s)}`
    },
    requestSmsVerificationCode() {
      this.$store.state.member.smsVerificationSent.success = false
      if (this.$refs.registerForm2.validate()) {
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_REQUEST}`, {
          registerObj
        })
      }
    },
    async verifySmsCode() {
      if (this.$refs.registerForm.validate()) {
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_VERIFY}`, {
          registerObj
        })
      }
    },
    checkAffiliateReferralCode() {
      let referCode = uiHelper.getCookie(SESSION.REFER_CODE)
      let afCode = uiHelper.getCookie(SESSION.AFF_CODE)
      let fbPixelCode = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
      if (afCode != null && afCode != '') {
        this.registerObj.agent_team = afCode
        this.isReferralCodeReadonly = true
      } else if (referCode != null && referCode != '') {
        this.registerObj.referralCode = referCode
        this.isReferralCodeReadonly = true
      } else {
        this.registerObj.referralCode = ''
        this.isReferralCodeReadonly = false
      }
    },
    nextPage() {
      if (this.$refs.registerForm1.validate() && !this.userNameErrorMsg) {
        this.step++
      }
    },
    previousPage() {
      this.step--
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    }
  }
}
</script>

<style lang="scss">
.register-landing-check-box .mdi-checkbox-blank-outline {
  color: white;
}
.register-landing-text-field {
  .v-input input,
  .v-input input::placeholder,
  .v-input textarea {
    color: white;
  }
  .v-select__selection {
    color: white !important;
  }
}
.back-button-landing-page {
  position: absolute;
  top: 5%;
  left: 5%;
  z-index: 10;
  .mdi-arrow-left::before {
    color: white;
  }
}
.register-landing {
}
.registerformfield .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-size: 14px;
}

.specialgrey .input-field-login .v-input__control .v-input__slot {
  background-color: rgba(0, 0, 0, 0.1);
}

.registerformfield .input-field-login .v-input__control .v-input__slot {
  min-height: 30px;
  height: 30px;
}

.registerformfield .v-input__control .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
}

.register_panel-af {
  justify-content: center;

  .register-wrapper-af {
    max-width: 1240px;
    margin: auto;
    //border: 8px solid var(--v-primary-base);
    display: flex;
    padding: 16px 12px;
    justify-content: space-between;
    gap: 1em;

    .sign-up-title {
      justify-content: center;
      color: var(--v-secondary-base);
      border-bottom: 1px solid var(--v-secondary-base);
      padding-bottom: 0.5em;
      margin-bottom: 1.5em;
    }

    .circle-button {
      padding: 12px;
      border-radius: 4px;
      height: 45px;
      background-color: var(--v-primary-lighten1);
    }

    .circle-button:hover {
      background-color: var(--v-primary-base);
    }

    .otp-button {
      background-color: var(--v-primary-base);
      border-radius: 4px;
    }

    .v-select__selection {
      color: #000000;
    }

    .input-field .v-icon,
    .input-field .v-input__icon {
      color: var(--v-primary-base);
    }

    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
      margin-top: 0px;
    }
  }
}

@media (max-width: 599px) {
  .register_panel-af {
    background-color: #ffffff;

    .register-wrapper-af {
      border: unset;
    }
  }
}

@media (max-width: 440px) {
  .input-field .v-input__slot .v-select__slot .v-select__selections .v-select__selection--comma {
    font-size: 12.5px;
  }
}
</style>
